import { cloneDeep } from 'lodash'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes,
  components,
  getEmptyFallback,
  icons,
  isArrayNotEmpty,
  routerQueryReplace,
  states } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import preview from '@/components/services/sendings/preview'
import confirmButton from '@/components/services/sendingsCreate/buttons/confirm'
import saveTemplateButton from '@/components/services/sendingsCreate/buttons/template'
import fallbacks from '@/components/services/sendingsCreate/fallbacks'
import sendingsCreateForm from '@/components/services/sendingsCreate/form'
import recipients from '@/components/services/sendingsCreate/recipients'
import schedule from '@/components/services/sendingsCreate/schedule'
import title from '@/components/services/sendingsCreate/title'
import templates from '@/components/services/templates/template'

function renderWarning(h) {
  return h(
    components.card,
    {
      props: {
        flat: true,
        maxWidth: 600
      }
    },
    [
      h(
        info,
        {
          props: {
            value: this.getTranslate(`${Services.sendings}.contents.noAllowedSendingTypes`),
            color: Colors.error
          }
        }
      )
    ]
  )
}

function renderRecipients(h) {
  return h(
    recipients,
    {
      props: {
        value: this.restData[Services.sendings].create.data.recipient
      },
      on: {
        input: event => {
          this.restData[Services.sendings].create.data.recipient = event
        }
      }
    }
  )
}
function renderTitleField(h) {
  return h(
    title,
    {
      props: {
        value: this.restData[Services.sendings].create.data.$options?.title,
        disabled: !this.isBulk
      },
      on: {
        input: event => {
          this.restData[Services.sendings].create.data.$options.title = event
        }
      }
    }
  )
}
function renderSendingsCreateForm(h) {
  if (!this.hasFallbacks) {
    return h(
      sendingsCreateForm,
      {
        props: {
          value: this.restData[Services.sendings].create.data,
          errors: this.restData[Services.sendings].create.errors,
          template: this.template,
          applyingTemplate: this.isApplyingTemplate
        },
        on: {
          input: event => {
            this.restData[Services.sendings].create.data = event
          },
          validation: event => {
            this.formValidation = event
          }
        }
      }
    )
  }
}

function renderFallbacks(h) {
  return h(
    fallbacks,
    {
      props: {
        value: this.restData[Services.sendings].create.data,
        defaultValue: getEmptyFallback(),
        applyingTemplate: this.isApplyingTemplate
      },
      on: {
        input: event => {
          this.restData[Services.sendings].create.data = event
        }
      }
    }
  )
}

function renderScheduled(h) {
  return h(
    schedule,
    {
      props: {
        value: this.restData[Services.sendings].create.data.schedule
      },
      on: {
        input: event => {
          this.restData[Services.sendings].create.data.schedule = event
        }
      }
    }
  )
}

function renderResetButton(h) {
  return h(
    button,
    {
      props: {
        icon: icons.clear,
        mode: buttonModes.flat,
        tooltip: this.getTranslate(`${Services.sendings}.tooltips.reset`)
      },
      on: {
        click: () => {
          this.reset()
        }
      }
    }
  )
}
function renderMessagePreviewButton(h) {
  if (this.viewport.size.width <= 1250) {
    return h(
      button,
      {
        props: {
          mode: buttonModes.outline,
          icon: icons.preview,
          color: Colors.primary,
          disabled: !this.validation,
          tooltip: this.getTranslate(`${Services.sendings}.tooltips.preview`)
        },
        on: {
          click: () => {
            routerQueryReplace({ currentTab: 'preview' })
          }
        }
      }
    )
  }
}
function renderSaveTemplateButton(h) {
  return h(
    saveTemplateButton,
    {
      props: {
        value: cloneDeep(this.restData[Services.sendings].create.data)
      }
    }
  )
}
function renderConfirmButton(h) {
  return h(
    confirmButton,
    {
      props: {
        value: this.restData[Services.sendings].create.data,
        loading: this.restData[Services.sendings].create.state === states.loading,
        disabled: !this.validation
      },
      on: {
        send: () => {
          return this.createSending()
        }
      }
    }
  )
}
function renderFooterButtons(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__footer-buttons`
    },
    [
      renderMessagePreviewButton.call(this, h),
      renderSaveTemplateButton.call(this, h),
      renderConfirmButton.call(this, h)
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__footer`
    },
    [
      renderResetButton.call(this, h),
      renderFooterButtons.call(this, h)
    ]
  )
}
function renderSendingsCreate(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__tab`,
      key: 'create'
    },
    [
      renderRecipients.call(this, h),
      renderTitleField.call(this, h),
      renderSendingsCreateForm.call(this, h),
      renderFallbacks.call(this, h),
      renderScheduled.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

function renderTemplates(h) {
  return h(
    templates,
    {
      key: Services.templates,
      on: {
        apply: event => {
          this.setTemplate(event)
        }
      }
    }
  )
}

function renderPreview(h) {
  return h(
    preview,
    {
      props: {
        value: this.restData[Services.sendings].create.data
      },
      key: 'preview'
    }
  )
}

function renderHeader(h, path) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__header`
    },
    [ this.getTranslate(path) ]
  )
}
function renderTabsHeader(h) {
  return h(
    components['tabs-header'],
    {
      props: {
        value: this.currentTab,
        tabs: this.tabs
      },
      on: {
        input: event => {
          routerQueryReplace({ currentTab: event })
        }
      }
    }
  )
}
function renderTabsContent(h) {
  return h(
    components.card,
    {
      props: {
        outline: true,
        rounded: true,
        overflow: true,
        maxWidth: 600
      }
    },
    [
      h(
        components.tabs,
        {
          props: { value: this.currentTab },
          scopedSlots: {
            body: () => {
              return [
                renderSendingsCreate.call(this, h),
                renderTemplates.call(this, h),
                renderPreview.call(this, h)
              ]
            }
          }
        }
      )
    ]
  )
}
function renderTabs(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__tabs`
    },
    [
      renderTabsHeader.call(this, h),
      renderTabsContent.call(this, h)
    ]
  )
}

function renderCard(h, title, content) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__content-card`
    },
    [
      renderHeader.call(this, h, title),

      h(
        components.card,
        {
          props: {
            outline: true,
            rounded: true,
            overflow: true,
            maxWidth: 600
          }
        },
        [ content ]
      )
    ]
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__content`
    },
    [
      renderCard.call(this, h, 'sendingsCreate.titles.message', renderSendingsCreate.call(this, h)),
      renderCard.call(this, h, `${Services.templates}.title`, renderTemplates.call(this, h)),
      renderCard.call(this, h, 'sendingsCreate.titles.preview', renderPreview.call(this, h))
    ]
  )
}
function renderContentByViewport(h) {
  if (!isArrayNotEmpty(this.sendingTypes)) {
    return renderWarning.call(this, h)
  }

  if (this.viewport.size.width > 1860) {
    return renderContent.call(this, h)
  }

  return renderTabs.call(this, h)
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create`
    },
    [ renderContentByViewport.call(this, h) ]
  )
}
